@if (convertedDimensions(); as dimensions) {
  <span>
    {{ dimensions.length | number: '1.0-2' }} x
    {{ dimensions.width | number: '1.0-2' }} x
    {{ dimensions.height | number: '1.0-2' }} m
  </span>
} @else {
  -
}
